import { Text, View } from "@react-pdf/renderer";
import React from "react";

import { sectionStyles } from "../styles";

interface ICommentPoint {
  title?: string;
  example?: string;
}

interface IReviewsCommentsSectionProps {
  positivePoints: ICommentPoint[] | undefined;
  negativePoints: ICommentPoint[] | undefined;
  labels: {
    positiveComments: string;
    negativeComments: string;
    commentExample: string;
    noComments: string;
  };
}

const CommentsList: React.FunctionComponent<{
  heading: string;
  points: ICommentPoint[] | undefined;
  commentExample: string;
  noComments: string;
}> = ({ heading, points, commentExample, noComments }) => (
  <View style={sectionStyles.commentsColumn}>
    <Text style={sectionStyles.subTitle}>{heading}</Text>
    <View style={sectionStyles.divider} />
    {points && points.length > 0 ? (
      <View style={sectionStyles.listContainer}>
        {points.map((point, index) => (
          <View key={index} style={sectionStyles.numberedListItem}>
            <View style={sectionStyles.listNumberContainer}>
              <Text style={sectionStyles.listNumber}>{index + 1}.</Text>
            </View>
            <View style={sectionStyles.contentContainer}>
              <Text style={sectionStyles.commentTitle}>{point.title}</Text>
              {point.example && (
                <Text style={sectionStyles.commentExample}>
                  {commentExample.replace("__example__", point.example)}
                </Text>
              )}
            </View>
          </View>
        ))}
      </View>
    ) : (
      <Text style={sectionStyles.noData}>{noComments}</Text>
    )}
  </View>
);

export const ReviewsCommentsSection: React.FunctionComponent<
  IReviewsCommentsSectionProps
> = ({ positivePoints, negativePoints, labels }) => {
  return (
    <View style={sectionStyles.container}>
      <View style={sectionStyles.commentsRow}>
        <CommentsList
          heading={labels.positiveComments}
          points={positivePoints}
          commentExample={labels.commentExample}
          noComments={labels.noComments}
        />
        <CommentsList
          heading={labels.negativeComments}
          points={negativePoints}
          commentExample={labels.commentExample}
          noComments={labels.noComments}
        />
      </View>
    </View>
  );
};
